import React from 'react';
import { IFieldFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import EntityCategoryDetails from '../../Builder/EntitySelection/details/EntityCategoryDetails';
import * as DictionaryEntityDetailsUI from './DictionaryEntityDetailsUI';

interface IProps {
  entity: IFieldFieldsFragment;
}

const DictionaryFieldDetails = ({ entity }: IProps) => {
  const tableNames = entity.tableNames;
  return (
    <DictionaryEntityDetailsUI.Container>
      {entity.categories?.length > 0 && (
        <EntityCategoryDetails entityCategories={entity.categories} />
      )}
      <DictionaryEntityDetailsUI.Description>
        {entity.description && (
          <>
            <DictionaryEntityDetailsUI.DescriptionTerm>
              Description:
            </DictionaryEntityDetailsUI.DescriptionTerm>
            {entity.description}
          </>
        )}
        {tableNames.length > 0 && (
          <>
            <DictionaryEntityDetailsUI.DescriptionTerm>
              Tables:
            </DictionaryEntityDetailsUI.DescriptionTerm>
            {tableNames.join(', ')}
          </>
        )}
      </DictionaryEntityDetailsUI.Description>
    </DictionaryEntityDetailsUI.Container>
  );
};

export default DictionaryFieldDetails;
